/**
 * Últimas Peças — preços dinâmicos 5% / 10% / 15% conforme peças elegíveis no carrinho.
 */
(function () {
  const EXCLUDED_HANDLES = new Set(['ebook-a-beleza-que-nao-te-ensinaram-a-ver']);

  function getCampaignHandles() {
    const el = document.getElementById('ultimas-pecas-campaign-product-handles');
    if (!el) return new Set();
    try {
      const handles = JSON.parse(el.textContent);
      return new Set(handles.filter(Boolean));
    } catch (e) {
      return new Set();
    }
  }

  function isEligibleCartItem(item, campaignHandles) {
    if (!item) return false;
    if (EXCLUDED_HANDLES.has(item.handle)) return false;
    if (campaignHandles.size > 0) {
      return campaignHandles.has(item.handle);
    }
    return false;
  }

  function countEligibleQuantity(cart) {
    if (!cart?.items?.length) return 0;
    const campaignHandles = getCampaignHandles();

    return cart.items.reduce((total, item) => {
      if (isEligibleCartItem(item, campaignHandles)) {
        return total + (item.quantity || 0);
      }
      return total;
    }, 0);
  }

  function getDiscountPercent(qty) {
    if (qty >= 3) return 15;
    if (qty === 2) return 10;
    return 5;
  }

  function getNextTierPercent(qty) {
    if (qty >= 3) return null;
    if (qty === 2) return 15;
    return 10;
  }

  function getBaseCentsForDisplay(priceEl) {
    const baseCents = parseInt(priceEl.dataset.basePriceCents, 10);
    const baseMinCents = parseInt(priceEl.dataset.basePriceMinCents, 10);
    const priceVaries = priceEl.dataset.priceVaries === 'true';

    if (!Number.isFinite(baseCents) || baseCents <= 0) return null;

    if (priceVaries) {
      return Number.isFinite(baseMinCents) && baseMinCents > 0 ? baseMinCents : baseCents;
    }

    return baseCents;
  }

  function discountedCents(baseCents, percent) {
    return Math.round((baseCents * (100 - percent)) / 100);
  }

  function formatMoney(cents) {
    const config = window.ultimasPecasPriceConfig || {};
    const currency = config.currency || 'EUR';

    let formatted;
    try {
      formatted = new Intl.NumberFormat(document.documentElement.lang || 'pt-PT', {
        style: 'currency',
        currency,
        minimumFractionDigits: 2,
      }).format(cents / 100);
    } catch (e) {
      formatted = `${(cents / 100).toFixed(2).replace('.', ',')} €`;
    }

    if (config.currencyCodeEnabled) {
      return `${formatted} ${currency}`;
    }

    return formatted;
  }

  function formatFromPrice(cents) {
    const config = window.ultimasPecasPriceConfig || {};
    const template = config.fromPriceTemplate || 'A partir de __PRICE__';
    const placeholder = config.fromPricePlaceholder || '__PRICE__';
    return template.split(placeholder).join(formatMoney(cents));
  }

  function ensureCompareElement(el) {
    const saleContainer = el.querySelector('.price__sale');
    if (!saleContainer) return null;

    let compareEl = saleContainer.querySelector('s.price-item--regular');
    if (compareEl) return compareEl;

    const compareWrap = document.createElement('span');
    compareWrap.className = 'price__compare';
    compareEl = document.createElement('s');
    compareEl.className = 'price-item price-item--regular';
    compareWrap.appendChild(compareEl);
    saleContainer.insertBefore(compareWrap, saleContainer.firstChild);

    return compareEl;
  }

  function applyDiscountToPriceElement(el, percent) {
    const baseCents = parseInt(el.dataset.basePriceCents, 10);
    const baseMinCents = parseInt(el.dataset.basePriceMinCents, 10);
    if (!Number.isFinite(baseCents) || baseCents <= 0) return;

    const applied = parseInt(el.dataset.ultimasPecasAppliedPercent, 10);
    const multiplier = 100 - percent;
    const priceVaries = el.dataset.priceVaries === 'true';
    const baseForDisplay = priceVaries
      ? Number.isFinite(baseMinCents) && baseMinCents > 0
        ? baseMinCents
        : baseCents
      : baseCents;
    const discountedCents = Math.round((baseForDisplay * multiplier) / 100);

    el.classList.add('price--on-sale', 'price--ultimas-pecas');
    el.classList.remove('price--no-compare');

    const compareEl = ensureCompareElement(el);
    let saleEl = el.querySelector('.price__sale .price-item--sale');

    if (compareEl) {
      compareEl.textContent = formatMoney(baseForDisplay);
    }

    if (saleEl) {
      saleEl.textContent = priceVaries ? formatFromPrice(discountedCents) : formatMoney(discountedCents);
    }

    el.dataset.ultimasPecasAppliedPercent = String(percent);

    if (applied !== percent) {
      el.setAttribute('data-ultimas-pecas-tier-changed', 'true');
    }
  }

  function updateSaleBadges(percent) {
    document.querySelectorAll('[data-ultimas-pecas-sale-badge]').forEach((el) => {
      el.textContent = `Promoção (-${percent}%)`;
      el.dataset.ultimasPecasSalePercent = String(percent);
    });
  }

  function updateCartTierLabels(qty, percent) {
    document.querySelectorAll('[data-ultimas-pecas-cart-tier]').forEach((el) => {
      if (qty === 0) {
        el.textContent = 'Preço com -5% (1 peça). Adiciona 2 peças elegíveis no carrinho para -10%.';
      } else if (qty === 1) {
        el.textContent = '1 peça elegível no carrinho — preço com -5%. Falta 1 peça para -10%.';
      } else if (qty === 2) {
        el.textContent = '2 peças elegíveis no carrinho — preço com -10%. Falta 1 peça para -15%.';
      } else {
        el.textContent = `${qty} peças elegíveis — desconto máximo de -15% aplicado.`;
      }
      el.hidden = false;
    });
  }

  function updateNextTierHints(qty) {
    const mainPriceEl = document.querySelector('.product__info-container [data-ultimas-pecas-dynamic-price]');
    const nextPercent = getNextTierPercent(qty);

    document.querySelectorAll('[data-ultimas-pecas-next-tier-hint]').forEach((el) => {
      el.classList.remove('ultimas-pecas-next-tier-hint--max');

      if (!mainPriceEl) {
        el.hidden = true;
        return;
      }

      const baseCents = getBaseCentsForDisplay(mainPriceEl);
      if (!baseCents) {
        el.hidden = true;
        return;
      }

      if (nextPercent == null) {
        el.textContent = 'Desconto máximo aplicado no carrinho (-15%).';
        el.classList.add('ultimas-pecas-next-tier-hint--max');
        el.hidden = false;
        return;
      }

      const nextPrice = formatMoney(discountedCents(baseCents, nextPercent));
      let message;

      if (qty === 2) {
        message = `Com mais 1 peça elegível: ${nextPrice} (-${nextPercent}%)`;
      } else if (qty === 1) {
        message = `Com mais 1 peça elegível: ${nextPrice} (-${nextPercent}%)`;
      } else {
        message = `Com 2 peças elegíveis no carrinho: ${nextPrice} (-${nextPercent}%)`;
      }

      el.textContent = message;
      el.hidden = false;
    });
  }

  function updateTierRows(percent, qty) {
    const nextPercent = getNextTierPercent(qty);

    document.querySelectorAll('[data-ultimas-pecas-tier-row]').forEach((row) => {
      const rowPercent = parseInt(row.dataset.ultimasPecasTierPercent, 10);
      const isActive = rowPercent === percent;
      const isNext = nextPercent != null && rowPercent === nextPercent;

      row.classList.toggle('is-active', isActive);
      row.classList.toggle('is-next', isNext && !isActive);
      row.setAttribute('aria-current', isActive ? 'true' : 'false');
    });
  }

  function hasUltimasPecasUI() {
    return (
      document.querySelector('[data-ultimas-pecas-dynamic-price]') ||
      document.querySelector('[data-ultimas-pecas-cart-tier]') ||
      document.querySelector('[data-ultimas-pecas-sale-badge]') ||
      document.querySelector('[data-ultimas-pecas-tier-row]') ||
      document.querySelector('[data-ultimas-pecas-next-tier-hint]')
    );
  }

  function refreshCartIconSection() {
    const target = document.getElementById('cart-icon-bubble');
    if (!target) return Promise.resolve();

    const root = window.shopUrl || window.location.origin || '';
    return fetch(`${root}/?section_id=cart-icon-bubble`)
      .then((r) => r.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const source = doc.getElementById('cart-icon-bubble');
        const section = doc.querySelector('.shopify-section');

        if (source) {
          target.innerHTML = source.innerHTML;
        } else if (section) {
          target.innerHTML = section.innerHTML;
        }
      })
      .catch(() => {});
  }

  function applyCartToPrices(cart) {
    const priceEls = document.querySelectorAll('[data-ultimas-pecas-dynamic-price]');
    const qty = countEligibleQuantity(cart);
    const percent = getDiscountPercent(qty);

    priceEls.forEach((el) => applyDiscountToPriceElement(el, percent));
    updateCartTierLabels(qty, percent);
    updateSaleBadges(percent);
    updateTierRows(percent, qty);
    updateNextTierHints(qty);

    return { qty, percent };
  }

  function syncCartState() {
    return fetch('/cart.js')
      .then((r) => r.json())
      .then((cart) => {
        if (hasUltimasPecasUI()) {
          applyCartToPrices(cart);
        }
        refreshCartIconSection();
        if (typeof window.updateFreeShippingProgress === 'function') {
          window.updateFreeShippingProgress(cart);
        }
        return cart;
      })
      .catch(() => null);
  }

  function fetchAndApplyPrices() {
    return syncCartState();
  }

  function updateUltimasPecasPrices() {
    if (!hasUltimasPecasUI() && !document.getElementById('cart-icon-bubble')) {
      return Promise.resolve(null);
    }
    return syncCartState();
  }

  function scheduleUpdate(delay = 250) {
    clearTimeout(window._ultimasPecasPriceTimer);
    window._ultimasPecasPriceTimer = setTimeout(syncCartState, delay);
  }

  function bindNavigationRefresh() {
    window.addEventListener('pageshow', (event) => {
      const navEntry = performance.getEntriesByType?.('navigation')?.[0];
      const isBackForward = navEntry?.type === 'back_forward';
      if (event.persisted || isBackForward) {
        scheduleUpdate(0);
      }
    });

    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        scheduleUpdate(120);
      }
    });
  }

  function bindCartInteractions() {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.quantity__button');
      if (btn && (e.target.closest('cart-items') || e.target.closest('cart-drawer-items'))) {
        scheduleUpdate(500);
      }
    });

    document.addEventListener('change', (e) => {
      const input = e.target;
      if (
        input?.type === 'number' &&
        (input.classList?.contains('quantity__input') || input.closest('quantity-input')) &&
        (input.closest('cart-items') || input.closest('cart-drawer-items'))
      ) {
        scheduleUpdate(500);
      }
    });
  }

  function init() {
    bindCartInteractions();
    bindNavigationRefresh();

    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        scheduleUpdate(200);
      });

      subscribe(PUB_SUB_EVENTS.variantChange, () => {
        scheduleUpdate(200);
      });
    }

    scheduleUpdate(80);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.updateUltimasPecasPrices = updateUltimasPecasPrices;
  window.scheduleUltimasPecasPriceUpdate = scheduleUpdate;
  window.syncUltimasPecasCartState = syncCartState;
})();
